document.addEventListener("DOMContentLoaded", function () {
    // On data-subnav avoid to close accordion onClick on data-subnav
    document.querySelector("[data-subnav]").addEventListener("click", (e) => {
        const accordionParent = e.target.closest(".accordion");
        accordionParent.classList.toggle("is-active");
    });

    // displays version number
    let packageFramework = require("../../../package.json");
    let versionNumbers = document.querySelectorAll("[data-version]");
    for (let i = 0; i < versionNumbers.length; i++) {
        versionNumbers[i].innerText = packageFramework.version;
    }

    // handles SUMMARY automatically generated
    let ids = document.querySelectorAll('.container[id]:not([id=""])');
    if (ids.length > 1) {
        let summaryContainer = document.querySelector("[data-subnav]");
        for (let i = 0; i < ids.length; i++) {
            let element = document.createElement("li");
            element.innerHTML =
                '<a href="#' +
                ids[i].getAttribute("id") +
                '">' +
                ids[i].children[0].innerHTML +
                "</a>";
            summaryContainer.appendChild(element);
        }
    }

    // scrollspy
    let sections = document.querySelectorAll("[data-content] .container");
    let offsets = [];
    for (let i = 0; i < sections.length; i++) {
        if (sections[i].id) {
            offsets[sections[i].id] = sections[i].offsetTop;
        }
    }
    let offsetFirstElement = sections[1].getBoundingClientRect().top;
    document.addEventListener("scroll", function () {
        let scrollPosition = window.scrollY;
        for (id in offsets) {
            if (offsets[id] <= scrollPosition + offsetFirstElement) {
                let links = document.querySelectorAll("[data-subnav] a");
                [].forEach.call(links, function (link) {
                    link.classList.remove("is-active");
                });
                document
                    .querySelector('a[href="#' + id + '"]')
                    .classList.add("is-active");
            }
        }
    });

    // scroll auto to the right entry on lateral navigation
    let customAdjustment = 42;
    let topActiveElement = document.querySelector("#nav .is-active .is-active");
    if (topActiveElement) {
        let positionActiveElement =
            topActiveElement.getBoundingClientRect().top - customAdjustment;
        document.querySelector("#nav").scrollTo(0, positionActiveElement);
    }

    // handles BURGER MENU on mobile
    let burger = document.querySelector('[data-trigger="menu"]');
    burger.addEventListener("click", function (e) {
        document.querySelector(".trigger-menu").classList.toggle("is-active");
        let toggles = document.querySelectorAll('[data-action="toggle-class"]');
        for (let i = 0; i < toggles.length; i++) {
            toggles[i].classList.toggle(toggles[i].getAttribute("data-class"));
        }
    });

    // handles OLD NAVBAR dropdown
    const dropdownOldNavbar = document.getElementById(
        "js-dropdown-documentation-old"
    );
    if (dropdownOldNavbar) {
        dropdownOldNavbar.addEventListener("click", function (e) {
            this.classList.toggle("is-active");
            e.preventDefault();
        });
    }

    // handles NEW NAVBAR dropdown
    const dropdownNewNavbar = document.getElementById(
        "js-dropdown-documentation-new"
    );
    if (dropdownNewNavbar) {
        dropdownNewNavbar.addEventListener("click", function (e) {
            this.classList.toggle("is-active");
            e.preventDefault();
        });
    }

    // handles NEW NAVBAR dropdown
    const dropdownGuestNewNavbar = document.getElementById(
        "js-dropdown-documentation-guest"
    );
    if (dropdownGuestNewNavbar) {
        dropdownGuestNewNavbar.addEventListener("click", function (e) {
            this.classList.toggle("is-active");
            e.preventDefault();
        });
    }

    // handles NEW NAVBAR dropdown
    const dropdownClientNewNavbar = document.getElementById(
        "js-dropdown-documentation-client"
    );
    if (dropdownClientNewNavbar) {
        dropdownClientNewNavbar.addEventListener("click", function (e) {
            this.classList.toggle("is-active");
            e.preventDefault();
        });
    }

    // Add is-active on dropdown
    const dropdown = document.querySelector(".js-dropdown-isactive");
    if (dropdown) {
        dropdown.addEventListener("click", function (e) {
            e.stopImmediatePropagation();
            this.classList.toggle("is-active");
            body.classList.toggle("dropdown-close");
        });
    }

    // Click on dropdown choice
    const dropdownItem = document.querySelectorAll(".dropdown-item");
    const dropdownInput = document.getElementById("filter_bte");
    const dropdownControl = document.querySelector(
        ".has-dynamic-placeholder-select"
    );
    dropdownItem.forEach((item) => {
        item.addEventListener("click", (e) => {
            e.stopImmediatePropagation();
            let value = item.textContent;
            dropdownInput.innerHTML =
                "<option value='1' selected='selected'>" + value + "</option>";
            dropdownItem.forEach((item) => {
                item.classList.remove("is-hovered");
            });
            item.classList.add("is-hovered");
            dropdown.classList.remove("is-active");
            body.classList.toggle("dropdown-close");
            dropdownControl.classList.add("has-placeholder-top");
        });
    });

    const body = document.body;

    body.addEventListener("click", function () {
        if (this.classList.contains("dropdown-close")) {
            dropdown.classList.remove("is-active");
            body.classList.remove("dropdown-close");
        }
    });

    // Transfer selection
    const check = document.querySelectorAll(".transfer .is-checkradio");
    if (check) {
        check.forEach((item) =>
            item.addEventListener("input", function () {
                item.parentElement.parentElement.classList.toggle("is-hovered");
            })
        );
    }

});
